import React from "react";
import { Button, Alert, Tag } from "antd";
import StatStrip from "../../../components/dashboard/StatStrip";
import { NAVY, RED, BLUE, GREEN } from "../gateway.constants";

function PreflightPanel({ report, onProceed, onFix, onBack }) {
  if (!report) return null;
  const { totalRows, sampledRows, errorCount, warningCount, issues = [], canProceed } = report;

  const stats = [
    { label: "Total rows", value: totalRows,    color: BLUE                             },
    { label: "Sampled",    value: sampledRows,  color: "#854F0B"                        },
    { label: "Errors",     value: errorCount,   color: errorCount   > 0 ? RED   : GREEN },
    { label: "Warnings",   value: warningCount, color: warningCount > 0 ? "#854F0B" : GREEN },
  ];

  return (
    <div>
      <StatStrip stats={stats} style={{ marginBottom: 20, borderRadius: 10 }} />

      {errorCount === 0 ? (
        <Alert type="success" showIcon style={{ marginBottom: 16 }}
          message="Pre-flight passed"
          description={`${sampledRows} rows sampled · ${warningCount} warnings`} />
      ) : (
        <Alert type="error" showIcon style={{ marginBottom: 16 }}
          message={`${errorCount} errors found in ${sampledRows} sampled rows`}
          description="Fix your data or proceed — invalid rows will be skipped." />
      )}

      {issues.length > 0 && (
        <div style={{
          maxHeight: 220, overflowY: "auto", marginBottom: 16,
          border: "0.5px solid var(--color-border-tertiary)", borderRadius: 8,
        }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11 }}>
            <thead>
              <tr style={{ background: "var(--color-background-secondary)" }}>
                {["Row", "Field", "Severity", "Issue"].map((h) => (
                  <th key={h} style={{
                    padding: "5px 8px", textAlign: "left",
                    borderBottom: "0.5px solid var(--color-border-tertiary)", fontWeight: 600,
                  }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {issues.slice(0, 100).map((issue, i) => (
                <tr key={i} style={{ borderBottom: "0.5px solid var(--color-border-tertiary)" }}>
                  <td style={{ padding: "4px 8px" }}>{issue.rowNumber || "—"}</td>
                  <td style={{ padding: "4px 8px", fontFamily: "monospace", fontSize: 10 }}>{issue.fieldName}</td>
                  <td style={{ padding: "4px 8px" }}>
                    <Tag color={issue.severity === "ERROR" ? "error" : "warning"} style={{ fontSize: 9 }}>
                      {issue.severity}
                    </Tag>
                  </td>
                  <td style={{ padding: "4px 8px" }}>{issue.message}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div style={{ display: "flex", gap: 10 }}>
        <Button onClick={onBack}>Back</Button>
        {!canProceed && <Button onClick={onFix}>Fix mapping</Button>}
        <Button type="primary" onClick={onProceed}
          style={{ background: canProceed ? NAVY : RED, borderColor: canProceed ? NAVY : RED }}>
          {canProceed ? "Proceed to generate →" : "Proceed with warnings →"}
        </Button>
      </div>
    </div>
  );
}

export default PreflightPanel;
